import {AmenityGroupType} from "@CheckOrder/features/amenities/types/AmenityGroup.type";
import Translation from "@Translation/components/Translation";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import IconTicketAmenityGroupNotAvailable from "@Icons/ticket/amenities/IconTicketAmenityGroupNotAvailable";
import useIsMobile from "@Hooks/selector/useIsMobile";

interface NoAmenitiesAvailableInThisDirectionNotificationProps {
    amenityGroupInDifferentDirection: AmenityGroupType,
    selectedTab: "single" | "return",
}

function NoAmenitiesAvailableInThisDirectionNotification(props: NoAmenitiesAvailableInThisDirectionNotificationProps) {
    const {
        amenityGroupInDifferentDirection: {
            translations: {
                modal: {
                    notAvailable,
                    notAvailableDescription,
                },
            },
            notAvailableIcon,
        },
        selectedTab,
    } = props

    const {
        departureStation: {
            cityName: departure,
        },
        destinationStation: {
            cityName: destination,
        },
    } = useAppSelector((state) => (state.checkOrder.purchasedRoute[selectedTab === "single" ? "singleRoute" : "returnRoute"].travelInfo))

    const isMobile = useIsMobile()

    return (
        <section className="ticket-amenities__no-amenities-notification">
            <IconTicketAmenityGroupNotAvailable
                {...notAvailableIcon}
                width={isMobile ? "64" : "80"}
                height={isMobile ? "64" : "80"}
            />
            <h5>
                <Translation translationKey={notAvailable}/>
            </h5>
            <p>
                <Translation
                    translationKey={notAvailableDescription}
                    translationVariables={{departure, destination}}
                />
            </p>
        </section>
    )
}

export default NoAmenitiesAvailableInThisDirectionNotification